import { queryOptions } from '@tanstack/react-query';

import { RecurringSubscriptionApi } from '@api/RecurringSubscriptionApi';

export const recurringSubscriptionTrialDurationKeys = {
    all: ['recurringSubscriptionTrialDuration'] as const,
};

export const recurringSubscriptionTrialDurationQueryOptions = {
    get: () =>
        queryOptions({
            queryKey: recurringSubscriptionTrialDurationKeys.all,
            queryFn: () => RecurringSubscriptionApi.getTrialDuration(),
        }),
};
